import type IsoDate from '../../../models/IsoDate';
import { requestAndParse, requestSuccessful } from '../request';

const setExpirationDate = async (userId: number, expirationDate: IsoDate) => {
    const route = 'admin/set-expiration-date';
    const payload = {
        userId,
        expirationDate,
    };

    const response = await requestAndParse(route, payload);

    const success = requestSuccessful(response);
    const message = response.body?.message as string;

    return { success, message };
};

export default setExpirationDate;
